import { generateTitleFromSlug } from "@helpers/titleHelpers";

export interface BreadcrumbItem {
  name: string;
  href: string;
  current?: boolean;
  vehicleMake?: string;
  vehicleModel?: string;
}

const ROUTE_MAP: Record<string, string> = {
  'cars': 'Cars',
  'gallery': 'Gallery',
  'price': 'Price',
  'mileage': 'Mileage',
  'collection': 'Cars',
  'variant': 'Variant',
  'search': 'Search',
  'wishlist': 'Wishlist',
  'review': 'Review',
  'quote': 'Quote',
  'mmv': 'MMV',
  'dimension': 'Dimension',
  'sister': 'Sister',
  'colors': 'Colors',
  'colours': 'Colors',
  'faq': 'FAQ',
  'specs-and-features': 'Specs & Features',
  'specifications': 'Specifications',
  'see-how-ratings-work': 'See how ratings work'
};

export const formatSegmentName = (segment: string): string => {
  if (segment.includes('+')) {
    return segment.split('+').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  }
  return segment.charAt(0).toUpperCase() + segment.slice(1);
};

export const pushCarsBreadcrumbOnce = (items: BreadcrumbItem[]) => {
  if (!items.some(item => item.name === 'Cars' && item.href === '/cars')) {
    items.push({ name: 'Cars', href: '/cars', current: false });
  }
};

export const getBreadcrumbName = (
  segment: string,
  allSegments: string[],
  currentIndex: number
): string => {
  if (currentIndex > 0 && allSegments[currentIndex - 1] === 'collection') {
    try {
      return generateTitleFromSlug(segment);
    } catch (error) {
      console.error('Error generating breadcrumb title from slug:', error);
    }
  }

  if (ROUTE_MAP[segment]) {
    return ROUTE_MAP[segment];
  }

  return formatSegmentName(segment);
};

export const generateFallbackBreadcrumbs = (path: string): BreadcrumbItem[] => {
  const segments = path.split('/').filter(segment => segment);
  const breadcrumbItems: BreadcrumbItem[] = [{ name: "Home", href: "/" }];

  let currentPath = '';
  segments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === segments.length - 1;

    const name = formatSegmentName(segment);
    breadcrumbItems.push({ name, href: currentPath, current: isLast });
  });

  return breadcrumbItems;
};
